import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Helmet from 'react-helmet';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import ManualeGiocoForm from '../components/manuale-giochi/ManualeGiocoForm';

function ManualeGiocoCreate() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const pageBg = useColorModeValue('gray.50', 'gray.900');
  const muted = useColorModeValue('gray.600', 'gray.400');

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/manuale-giochi', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Box bg={pageBg} minH="100vh" py={{ base: 6, md: 10 }}>
      <Container
        maxW={{ base: 'full', md: '7xl' }}
        px={{ base: 2, sm: 3, md: 4 }}
      >
        <Helmet>
          <title>Aggiungi un gioco | Manuale giochi CIL</title>
        </Helmet>

        <Button
          as={Link}
          to="/manuale-giochi"
          variant="link"
          colorScheme="teal"
          mb={4}
        >
          ← Manuale giochi
        </Button>

        <VStack align="stretch" spacing={2} mb={6}>
          <Heading size="lg">Aggiungi un gioco</Heading>
          <Text color={muted}>
            Compila la scheda come faresti nel manuale interno CIL. Verrà
            salvata come bozza in attesa di revisione.
          </Text>
        </VStack>

        <ManualeGiocoForm onSuccess={() => navigate('/manuale-giochi')} />
      </Container>
    </Box>
  );
}

export default ManualeGiocoCreate;
